import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { observer } from "mobx-react-lite";
import { StepCard } from "./StepCard";

const useStyles = makeStyles()((theme: Theme) => ({
	textField: {
		marginBottom: theme.spacing(5),
		width: theme.spacing(50),
		[theme.breakpoints.down("sm")]: {
			width: "100%",
		},
	},
	wrapper: {
		[theme.breakpoints.up("xs")]: {
			maxWidth: theme.spacing(60),
			padding: theme.spacing(7, 5),
		},
	},
}));

export const ThanksBadStep = observer(() => {
	const { classes } = useStyles();

	return (
		<StepCard
			hideAvatar
			hideStartImage
			className={classes.wrapper}
			title="reviewPage.thanksBadStep.title"
			subTitle="reviewPage.thanksBadStep.subTitle"
		/>
	);
});
